var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "79", height: "79", viewBox: "0 0 79 79", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M57.614 39.33L40.046 58 22.477 39.33c-4.636-4.667-4.636-12.16 0-16.704 4.636-4.667 12.079-2.58 16.593 2.088l.976.983.976-.983c4.636-4.667 12.078-6.632 16.592-2.088 4.515 4.545 4.515 12.037 0 16.704z", stroke: "#0165A7", strokeWidth: "2", strokeMiterlimit: "10" }),
    React.createElement("path", { d: "M61.153 77H17.847C9.137 77 2 69.863 2 61.153V17.968C2 9.138 9.137 2 17.847 2h43.185C69.862 2 77 9.137 77 17.968v43.185C77 69.863 69.863 77 61.153 77z", stroke: "#0165A7", strokeWidth: "2", strokeMiterlimit: "10" })
  );
});